/** Zone helpers — UI uses "zone" terminology; Firestore fields stay color_names, patch, etc. */

export const ZONE_TYPES = ['rgb', 'rgbw', 'rgba', 'rgbaw', 'rgbawu', 'rgbwau'];

export const DEFAULT_ZONE_TYPE = 'rgb';

export const DEFAULT_ZONE_COUNT = 4;

export function getZoneCount(system) {
	if (typeof system?.num_colors === 'number' && system.num_colors > 0) {
		return system.num_colors;
	}
	const names = system?.color_names || [];
	if (names.length > 0) return names.length;
	const patch = system?.patch || [];
	if (patch.length > 0) return patch.length;
	return DEFAULT_ZONE_COUNT;
}

/** Build zone objects from a system document for UI display/editing. */
export function getZonesFromSystem(system) {
	const count = getZoneCount(system);
	const names = system?.color_names || [];
	const descriptions = system?.color_descriptions || [];
	const patch = system?.patch || [];

	return Array.from({ length: count }, (_, i) => ({
		name: names[i] || '',
		description: descriptions[i] || '',
		type: patch[i]?.type || DEFAULT_ZONE_TYPE,
	}));
}

/** Convert zone editor state back to Firestore system fields. */
export function zonesToSystemFields(zones) {
	const safe = zones.map((z) => ({
		name: z.name || '',
		description: z.description || '',
		type: ZONE_TYPES.includes(z.type) ? z.type : DEFAULT_ZONE_TYPE,
	}));

	return {
		num_colors: safe.length,
		color_names: safe.map((z) => z.name),
		color_descriptions: safe.map((z) => z.description),
		patch: safe.map((z) => ({ type: z.type })),
	};
}

/** Resize the live color output array when zone count changes. */
export function resizeColorArray(existingColors, newCount) {
	const colors = [...(existingColors || [])];
	while (colors.length < newCount) {
		colors.push({ r: 0, g: 0, b: 0 });
	}
	return colors.slice(0, newCount);
}

export function defaultZoneName(index) {
	return `Zone ${index + 1}`;
}

export function formatZoneType(type) {
	return (type || DEFAULT_ZONE_TYPE).toUpperCase();
}
